import AddPlayerIcon from "../../../img/icons/add-person.svg?react";
import { addPlayer } from "./AddPlayer.css";
import { usePlosTranslations } from "../../../contexts/PlosTranslationsContext";

const AddPlayer = () => {
  const { addPlayer: addPlayerText } = usePlosTranslations();
  const label = addPlayerText();
  return (
    <AddPlayerIcon
      className={addPlayer}
      role="img"
      title={label}
      aria-label={label}
    />
  );
};

export default AddPlayer;
